
import React from 'react';
import * as api from '../../../../../api';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css'
import { Icon } from 'semantic-ui-react'

class UserSubRolesTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      allRolesList: [],
      selected: []
    };
    this.fetchData();
    this.onChange = this.onChange.bind(this);


  }
  fetchData() {

    api.getRolesList(this.props.customerId)
      .then(data => {
        this.setState({ allRolesList: data.filter(x => x.roleName !== "Client User All" && x.roleName !== "Client User" && x.roleName !== "Admin" && x.roleName !== "Inenco User") });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });

    api.getUserSubRoles(this.props.id)
      .then(data => {
     
        this.setState({ selected: data.filter(x => x.roleName !== "Client User All" && x.roleName !== "Client User" && x.roleName !== "Admin" && x.roleName !== "Inenco User").map((item) => { return item.roleId.toString() }) });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
  }

  onChange(selected, selection) {
    
    if (selected.length > 0 && selection.length > 0) {
      for (let item of selection) {
        if (selected.includes(item)) {
          api.addUserSubRoles(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length >= 0 && selection.length > 0) {
      for (let item of selection) {
        if (!selected.includes(item)) {
          api.removeUserSubRoles(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length > 0 && selection.length === 0) {
      for (let item of selected) {
        api.addUserSubRoles(this.props.id, item)
          .then((data) => {
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }

    this.setState({ selected });
  }

  render() {
   
    const options = this.state.allRolesList.map((item) => { return { value: item.roleId, label: item.roleName } })
    const { selected } = this.state;

    return (
      <div>
        <div className="list-sites-flex">
          <div className="list-sites"> List of Available Roles </div>
          <div className="list-sites mr-sites"> User’s Roles </div>
        </div>
        <DualListBox
          options={options}
          selected={selected}
          onChange={this.onChange}
          className="edit-user-btn"
          icons={{
            moveLeft: <Icon className="long arrow alternate left" ></Icon>,
            moveRight: <Icon className="long arrow alternate right" ></Icon>,
            // moveAllRight: <span>Add All</span>,
          }}
        />
      </div>
    );
  }

}
export default UserSubRolesTab